<p-floatLabel>
    <p-select #areaSelector
        id="areaSelector"
        name="areaSelector"
        [options]="areas"
        [(ngModel)]="selectedArea"
        [showClear]="true"
        [filter]="true"
        [appendTo]="'body'"
        [checkmark]="true"
        [disabled]="isEmptyString(parentId) && isSubArea || isDisabled"
        styleClass="w-100"
        (onChange)="onSelected()"
        optionLabel="organizationUnitName">
        <ng-template let-option pTemplate="item">
            {{ option?.organizationUnitName }}
        </ng-template>
    </p-select>
    <label for="areaSelector">
        <app-label-content [isRequired]="isRequired">
            {{ getLabel() }}
        </app-label-content>
    </label>
</p-floatLabel>
